import { cdnCommonPath } from "@/constants/cdnUrls";
import { LANGUAGE_NAMES } from "@/constants/languages";
import { useLanguageAndCurrency } from "@/hooks/useLanguageAndCurrency";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { commonService } from "@/services/commonService";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import Image from "next/image";
import { useEffect, useState } from "react";
import { Button } from "./ui/Button";
import Spinner from "./ui/Spinner";

const MobileLanguageSelector = ({ onChangeComplete }) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(false);
  const t = useTranslationDetector();
  const {
    selectedLanguage,
    handleLanguageChange,
    applyChanges,
    loading: languageLoading,
  } = useLanguageAndCurrency();
  const getLanguages = async () => {
    try {
      setLoading(true);
      const response = await commonService.getLanguages();
      if (response?.Cultures) {
        setLanguages(
          response.Cultures.map((culture) => ({
            value: culture.LanguageCode,
            label: culture.LanguageName,
          })),
        );
      } else {
        setLanguages(
          Object.entries(LANGUAGE_NAMES).map(([code, info]) => ({
            value: code,
            label: info.name,
          })),
        );
      }
    } catch (error) {
      console.error("MobileLanguageSelector: Error getting languages:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getLanguages();
  }, []);

  return loading ? (
    <div className="flex items-center justify-between p-4">
      <span className="flex items-center gap-2">
        <span>
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["globe"]}
            className="text-[20px]"
          />
        </span>
        <span>{t("common.loading")}</span>
      </span>
      <Spinner className="h-4 w-4 animate-spin" />
    </div>
  ) : (
    <div className="flex h-full flex-col justify-between">
      <div className="max-h-[360px] flex-1 overflow-y-auto px-4">
        {languages.map((language, index) => (
          <button
            key={language.value}
            className={clsx("flex w-full items-center justify-between py-4")}
            onClick={() => {
              handleLanguageChange(language.value);
            }}
          >
            <span className="flex items-center gap-3">
              <span
                className={clsx(
                  "text-foreground border-border-strong flex h-6 w-6 items-center justify-center rounded-full border px-2 py-1 font-medium",
                  selectedLanguage === language.value && "bg-primary border-0",
                )}
              >
                <span className="flex h-2 w-2 rounded-full bg-white"></span>
              </span>
              <span>{language.label}</span>
            </span>

            <Image
              src={cdnCommonPath + `${language.value}.svg`}
              alt={language.value}
              width={24}
              height={24}
            />
          </button>
        ))}
      </div>
      <div className="border-border-weaker border-t p-4">
        <Button
          className="w-full"
          size="lg"
          onClick={() => applyChanges(onChangeComplete)}
          loading={languageLoading}
        >
          {t("languageandcurrency.save")}
        </Button>
      </div>
    </div>
  );
};

export default MobileLanguageSelector;
